<template>
    <div>
        <div v-if="view" class="fixed z-10 inset-0 overflow-y-auto">
                <div class="flex outturns-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
                    <div class="fixed inset-0 transition-opacity" aria-hidden="true" @click="view = false">
                        <div class="absolute inset-0 bg-gray-500 opacity-75"></div>
                    </div>

                    <!-- This element is to trick the browser into centering the modal contents. -->
                    <span class="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">&#8203;</span>
                    <div class="inline-block align-bottom bg-white rounded-lg  text-left overflow-hidden shadow-xl transform transition-all ease-out duration-300 sm:my-8 sm:align-middle sm:max-w-5xl sm:w-full" role="dialog" aria-modal="true" aria-labelledby="modal-headline">
                        <div class="flex justify-between outturns-center mb-4 bg-blue-50 border-b border-blue-100 p-4">
                            <p class="text-xl font-semibold text-blue-900">Invoice</p>
                            <a :href="`/contracts/invoice/${invoice.id}`" target="_blank" class="flex items-center text-blue-600 cursor-pointer">
                                <svg class="w-6 h-6 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 17h2a2 2 0 002-2v-4a2 2 0 00-2-2H5a2 2 0 00-2 2v4a2 2 0 002 2h2m2 4h6a2 2 0 002-2v-4a2 2 0 00-2-2H9a2 2 0 00-2 2v4a2 2 0 002 2zm8-12V5a2 2 0 00-2-2H9a2 2 0 00-2 2v4h10z"></path></svg>
                                <span class="font-semibold">Print / Export</span>
                            </a>
                            <svg @click="view = false" class="w-6 h-6 text-gray-400 cursor-pointer hover:text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path></svg>
                        </div>
                        <div class="px-4 pt-1 pb-4 sm:p-6 lg:grid lg:grid-cols-12 lg:gap-x-8">
                            <section class="col-span-12 mb-3 w-full p-2 text-2xl -mt-4 border border-blue-900 text-center font-bold tracking-wider text-blue-900">INVOICE</section>
                            <section class="lg:col-span-6">
                                <div class="w-full mb-4 text-blue-900">
                                    <h1 class="text-2xl font-bold">Valley Co-op Oil Mill .</h1>
                                    <p class="">PO Box 841</p>
                                    <p>Lubbock, TX 79408-0841</p>
                                    <p class="">Phone: 806.747.3434</p>
                                    <p>Fax: 806.744.3221</p>
                                </div>
                                <div class="col-span-12 text-gray-700 tracking-wider py-4 font-thin">
                                    <p class="text-xs mb-1 font-medium uppercase">Ship To:</p>
                                    <p class="font-mono">{{ invoice.shipper_name}}</p>
                                    <p class="font-mono">{{ invoice.ship_to_name }}</p>
                                </div>
                                <div class="col-span-12 text-gray-700 tracking-wider py-4 font-thin">
                                    <p class="text-xs mb-1 font-medium uppercase">Sold To:</p>
                                    <p class="font-mono">{{ $page.props.auth.user.name }}</p>
                                    <p class="font-mono"> --- </p>
                                    <p class="font-mono"> --- </p>
                                </div>
                                <div class="col-span-12 text-gray-700 tracking-wider py-4 font-thin">
                                    <p class="text-xs mb-1 font-medium uppercase">Account Number:</p>
                                    <p class="font-mono">{{ invoice.division_number }} - {{ invoice.account_number }}</p>
                                </div>
                            </section>
                            <section class="lg:col-span-6 lg:grid lg:grid-cols-12 lg:gap-4">
                                <div class="lg:col-span-6">
                                    <div class="border border-blue-200">
                                        <div class="p-1 bg-blue-200 text-center text-blue-900 text-xs font-medium uppercase">Invoice Date</div>
                                        <div class="p-2 text-center text-gray-700 text-sm font-medium font-mono">{{ invoice.invoice_date | niceDate }}</div>
                                    </div>
                                </div>
                                <div class="lg:col-span-6">
                                    <div class="border border-blue-200">
                                        <div class="p-1 bg-blue-200 text-center text-blue-900 text-xs font-medium uppercase">Invoice Number</div>
                                        <div class="p-2 text-center text-gray-700 text-sm font-medium font-mono">{{ invoice.invoice_number }}</div>
                                    </div>
                                </div>
                                <div class="lg:col-span-6">
                                    <div class="border border-blue-200">
                                        <div class="p-1 bg-blue-200 text-center text-blue-900 text-xs font-medium uppercase">Shipping Date</div>
                                        <div class="p-2 text-center text-gray-700 text-sm font-medium font-mono">{{ invoice.ticket_date | niceDate }}</div>
                                    </div>
                                </div>
                                <div class="lg:col-span-6">
                                    <div class="border border-blue-200">
                                        <div class="p-1 bg-blue-200 text-center text-blue-900 text-xs font-medium uppercase">Terms</div>
                                        <div class="p-2 text-center text-gray-700 text-sm font-medium font-mono">NCRI</div>
                                    </div>
                                </div>
                                <div class="col-span-12 text-xs font-thin uppercase p-2 bg-gray-50 text-gray-800">
                                    ACCOUNTS NOT PAID MONTH FOLLOWING DELIVERY ARE SUBJECT TO A SERVICE CHARGE AT THE MAXIMUM LEGAL RATE ALLOWED BY LAW.  ALL ACCOUNTS ARE PAYABLE AT LUBBOCK, LUBBOCK COUNTY, TEXAS.  SALE GOVERNED IN ACCORDANCE WITH THE LAWS OF THE STATE OF TEXAS.
                                </div>
                                <div class="col-span-12 text-blue-900 bg-blue-100 p-4">
                                    <p class="text-xs mb-1 font-medium uppercase">Remit To:</p>
                                    <p class="font-bold">Valley Co-op Oil Mill .</p>
                                    <p class="font-bold">P.O. Box 841</p>
                                    <p class="font-bold">Lubbock, TX 79408-0841</p>
                                </div>
                            </section>
                            <hr class="col-span-12 my-6" />
                            <section class="col-span-12 grid grid-cols-10 gap-4">
                                <div class="border border-gray-200 col-span-2">
                                    <div class="p-1 bg-gray-200 text-center text-gray-900 text-xs font-medium uppercase">Scale Number</div>
                                    <div class="p-2 text-center text-gray-700 text-sm font-medium font-mono">{{ invoice.invoice_sequence_number }}</div>
                                </div>
                                <div class="border border-gray-200 col-span-2">
                                    <div class="p-1 bg-gray-200 text-center text-gray-900 text-xs font-medium uppercase">Contract Number</div>
                                    <div class="p-2 text-center text-gray-700 text-sm font-medium font-mono">{{ invoice.contract_number }}</div>
                                </div>
                                <div class="border border-gray-200 col-span-2">
                                    <div class="p-1 bg-gray-200 text-center text-gray-900 text-xs font-medium uppercase">Truck/Car Number</div>
                                    <div class="p-2 text-center text-gray-700 text-sm font-medium font-mono">{{ invoice.car_id_number }}</div>
                                </div>
                                <div class="border border-gray-200 col-span-2">
                                    <div class="p-1 bg-gray-200 text-center text-gray-900 text-xs font-medium uppercase">Customer Number</div>
                                    <div class="p-2 text-center text-gray-700 text-sm font-medium font-mono">{{ invoice.customer_order_number }}</div>
                                </div>
                                <div class="border border-gray-200 col-span-2">
                                    <div class="p-1 bg-gray-200 text-center text-gray-900 text-xs font-medium uppercase">Our Order Number</div>
                                    <div class="p-2 text-center text-gray-700 text-sm font-medium font-mono">{{ invoice.bill_of_lading_number }}</div>
                                </div>
                            </section>
                            <section class="border border-gray-200 bg-gray-200 gap-0.5 col-span-12 grid grid-cols-7 mt-6">
                                <div class="bg-white col-span-1">
                                    <div class="p-1 bg-gray-200 text-center text-gray-900 text-xs font-medium uppercase">Item</div>
                                    <div class="p-2  text-gray-700 text-sm font-medium font-mono">{{ invoice.product_code }}</div>
                                </div>
                                <div class="bg-white col-span-3">
                                    <div class="p-1 bg-gray-200 text-center text-gray-900 text-xs font-medium uppercase">Description</div>
                                    <div class="p-2  text-gray-700 text-sm font-medium font-mono">{{ invoice.product_description }}</div>
                                </div>
                                <div class="bg-white col-span-1">
                                    <div class="p-1 bg-gray-200 text-center text-gray-900 text-xs font-medium uppercase">Qty Shipped</div>
                                    <div class="p-2 text-right text-gray-700 text-sm font-medium font-mono">{{ invoice.units_before_conversion | numberInThousands }}</div>
                                </div>
                                <div class="bg-white col-span-1">
                                    <div class="p-1 bg-gray-200 text-center text-gray-900 text-xs font-medium uppercase">Unit Price</div>
                                    <div class="p-2 text-right text-gray-700 text-sm font-medium font-mono">{{ invoice.unit_charge_price }}</div>
                                </div>
                                <div class="bg-white col-span-1">
                                    <div class="p-1 bg-gray-200 text-center text-gray-900 text-xs font-medium uppercase">Amount</div>
                                    <div class="p-2 text-right text-gray-700 text-sm font-medium font-mono">{{ total(invoice) | currency }}</div>
                                </div>

                            </section>
                            <section class="gap-0.5 col-span-12 grid grid-cols-7 mb-12">
                                <div class="bg-white col-span-4">
                                    <div class="p-2 text-right text-blue-900 text-sm font-medium uppercase">Invoice Totals</div>
                                </div>
                                <div class="bg-blue-100 col-span-1">
                                    <div class="p-2 text-right text-blue-900 text-sm font-bold font-mono uppercase">{{ invoice.units_before_conversion | numberInThousands }}</div>
                                </div>
                                <div class="bg-white col-span-1">
                                    <div class="p-2"></div>
                                </div>
                                <div class="bg-blue-100 col-span-1">
                                    <div class="p-2 text-right text-blue-900 text-sm font-bold font-mono uppercase">{{ total(invoice) | currency }}</div>
                                </div>
                            </section>
                        </div>
                    </div>
                </div>
            </div>

    </div>
</template>

<script>

export default {
    data() {
        return {
            invoice: {},
            view: false,
        }
    },
    mounted() {
        this.$eventBus.$on('show-contract-invoice', (invoice) => {
            this.invoice = invoice
            this.view = true
        })
    },
    methods: {
        convertedUnits(item) {
            //  0 = PER TON
            //  1 = PER POUND
            //  2 = PER ITEM

            // convert to tons if needed
            if (item.invoice_pricing?.price_type === 0) {
                return item.units_before_conversion / 2000
            }

            return item.units_before_conversion

        },
        total(item) {
            return this.convertedUnits(item) * item.unit_charge_price
        },
    }
}
</script>
